import * as React from 'react';
export const TvB2BPacketDetailsContext = React.createContext({
    packagesResponse: {
        packagePrices: [],
        viewerSlots: {},
        packageNames: [],
        channels: [],
        categoriesList: {},
        themePackages: [],
        additionalServices: [],
        packageSizes: [],
    },
    filterState: {
        channelSuggestionItems: [],
        selectedItem: null,
        selectedPackages: [],
        selectedThemes: [],
        fuzzySearch: null,
        isAllChannelsShown: false,
        isAllThemesShown: false,
        isAllServicesShown: false,
    },
    filterActions: {
        selectSuggestionItem: () => undefined,
        setSelectedPackages: () => undefined,
        setSelectedThemes: () => undefined,
        toggleAllThemesShown: () => undefined,
        toggleAllChannelsShown: () => undefined,
        toggleAllServicesShown: () => undefined,
    },
    urlData: null,
});
